import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CompanyRole } from '../models/company-role.model';
import { OAuthUserInfo } from '../models/oauthuserinfo.model';
import { ApiService } from './api.service';
import { SessionStorageService } from './session-storage.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AdminRolesCompaniesService {

  private getRolesMap = new BehaviorSubject<Object>(null);
  public rolesMap$ = this.getRolesMap.asObservable();

  private getCompaniesMap = new BehaviorSubject<Object>(null);
  public companiesMap$ = this.getCompaniesMap.asObservable();

  public setRolesMap(map: Object) {
    console.log("Setting roles", map);
    this.getRolesMap.next(map);
  }

  public setCompaniesMap(map: Object) {
    console.log("Setting companies", map);
    this.getCompaniesMap.next(map);
  }

  userSubscription: Subscription;
  arvCompanyId: string | string[];
  companyRoles: CompanyRole[];

  constructor(private userService: UserService, private sessionStorage: SessionStorageService, private apiService: ApiService) {
    this.userSubscription = this.sessionStorage.userInfosChange.subscribe((user: string) => {
      let info: OAuthUserInfo = JSON.parse(user);
      this.arvCompanyId = info.arvCompanyID;

      if (!this.companyRoles) {
        this.getRolesAndCompanies();
      }

    });
  }

  getAdminRoles(userId: string) {
    return this.apiService.get(`/users/roles/${userId}`);
  }

  getRolesAndCompanies() {
    let rolesMap = {}
    let companiesMap = {};

    this.userService.getRolesAndCompanies().then((companyRoles: CompanyRole[]) => {
      this.companyRoles = companyRoles;

      this.companyRoles.forEach((role: CompanyRole) => {
        rolesMap[role.roleName] = role.roleId;
      });

      // Companies
      companyRoles.forEach((role: CompanyRole) => {
        companiesMap[role.companyName] = role.companyId
      });

      this.setRolesMap(rolesMap);
      this.setCompaniesMap(companiesMap);
    });

  }

}